import { Icon } from "../../assets/icons/Icon";
import Spinner from "../ui/spinner/Spinner";
import styles from "./WidgetStatus.module.scss";

export const WidgetStatus = ({
  widgetInstalled,
}: {
  widgetInstalled: boolean;
}) => {
  return (
    <p>
      <Icon
        iconName={widgetInstalled ? "GreenCheckmarkIcon" : "DangerIcon"}
        color={
          widgetInstalled ? "var(--service-green3)" : "var(--service-red3)"
        }
        className={styles.widgetStatusIcon}
      />{" "}
      <span>
        {widgetInstalled
          ? "Widget installed"
          : "Widget not Installed. Checking..."}
      </span>
      {!widgetInstalled && (
        <>
          {" "}
          <Spinner size="1rem" className={styles.spinner} />
        </>
      )}
    </p>
  );
};
